import React from "react";
import logo from "./assets/devtrexapp.png";
import "./policy.css";

const PrivacyPolicy = () => {
  return (
    <div className="policy-wrapper">
      {/* Header */}
    <header className="policy-header">
  <div className="logo-box">
    <img src={logo} alt="Devtrex Logo" className="logo" />
  </div>
  <h1>Privacy Policy</h1>
  <p className="app-name">Fit Track Pro</p>
</header>


      {/* Content */}
      <div className="policy-container">
        <p className="updated">
          Last updated: {new Date().toLocaleDateString()}
        </p>
<h2>Introduction</h2>
<p>
  Fit Track Pro respects your privacy. This Privacy Policy explains how
  information is handled when using the Fit Track Pro mobile application,
  a fitness and gym tracking app designed to help users manage workouts,
  reminders, and healthy habits.
</p>

<h2>Information Collection</h2>
<p>
  Fit Track Pro does <strong>not collect, store, or share</strong> any
  personal information such as name, phone number, email address, payment
  details, or location data.
</p>

<h2>Local Data Storage</h2>
<p>
  All app data such as workout notes, reminders, and settings are stored
  locally on your device only. This data never leaves your device and is
  not uploaded to any server.
</p>

<h2>Notifications</h2>
<p>
  Fit Track Pro uses <strong>local notifications</strong> only to remind
  users about workouts, meals, hydration, supplements, or other fitness
  activities.
</p>
{/* <p>
  The app does <strong>not use push notifications</strong>, does not use
  notification tokens, and does not send data to external servers for
  notification purposes.
</p> */}
<p>
  Notification permissions can be enabled or disabled anytime from your
  device settings.
</p>

<h2>Permissions</h2>
<p>
  Fit Track Pro requests only the minimum permissions required for core
  app functionality, such as notification access. These permissions are
  used strictly for fitness-related features.
</p>

<h2>Third-Party Services</h2>
<p>
  Fit Track Pro does not integrate analytics, advertising SDKs, or
  third-party tracking tools. Any platform-level services (such as system
  notification services) operate under their respective privacy policies.
</p>

<h2>Children’s Privacy</h2>
<p>
  Fit Track Pro is not intended for children under the age of 13. The app
  does not knowingly collect any information from children.
</p>

<h2>Data Security</h2>
<p>
  Since no personal data is collected or transmitted, user privacy is
  protected by design. All data remains under the user's control on their
  own device.
</p>

<h2>Changes to This Policy</h2>
<p>
  This Privacy Policy may be updated from time to time. Any changes will
  be reflected within the app or on this page.
</p>

<h2>Contact Information</h2>
<div className="contact-box">
  <p><strong>Developer:</strong> Pranav Bhosale</p>
  <p><strong>Company:</strong> Devtrex App Development</p>
  <p>
    <strong>Email:</strong>{" "}
    <a href="mailto:devtrexapp@gmail.com">
      devtrexapp@gmail.com
    </a>
  </p>
</div>

      
    </div>
    </div>
  );
};

export default PrivacyPolicy;
